// PostHog product analytics. Each page script imports this module first.
import posthog from "posthog-js";

// Only the production build sends events. The key is a public project key.
if (import.meta.env.PROD) {
  posthog.init("phc_oGgVW2MYMDhnPmkhJSxgmEocEu7ZAuoqmdHuHqjEnd6z", {
    api_host: "https://us.i.posthog.com",
    defaults: "2026-05-30",
    person_profiles: "identified_only",
  });
}

// A product event. No text from people (comments, file names): only IDs, counts and flags.
export function track(event: string, properties: Record<string, string | number | boolean>): void {
  if (import.meta.env.PROD) posthog.capture(event, properties);
}
